import { NonStreamReportValue } from "@frameworks/web/components/features/Markets/Equity/commonTablemethods";
import ReadMoreTextWithReRender from "@frameworks/web/components/generic/ReadMoreText/ReadMoreTextWithReRender";
import ReportsGenericTable from "@frameworks/web/components/generic/ReportsGenericTable";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import LoadDataOnscroll from "./LoadDataOnscroll";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import AlltxnsOfAllScripsCards from "./AlltxnsOfAllScripsCards";
import FilterFlags from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/FilterFlags";
import { NuvamaAssets, NuvamaProducts, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { ESortOrder } from "@domains/utils/sort";
import { sortlistTH } from "../Constant";
import txnDI from "@frameworks/web/components/Reports/TransactionHistory/di/servicelocator";
import mainDI from "@frameworks/web/di/index";
const AlltxnsOfAllScrips = (props) => {
    const device = DeviceContext();
    const [sortState, setSortState] = React.useState(sortlistTH);
    const [finalSortState, setFinalSortState] = React.useState(sortlistTH.list[0]);
    const { reducersData: THData } = useSelector((state) => state.TransactionHistory.transactionHistory);
    const applySort = (key, dataType, order) => {
        let newOrder;
        if (key === "transactionDate")
            newOrder = order ? ESortOrder.DESC : ESortOrder.ASC;
        else
            newOrder = order ? ESortOrder.ASC : ESortOrder.DESC;
        let currentSortstate = {
            title: key,
            key: key,
            order: newOrder,
            orderText: {
                asc: "",
                desc: "",
            },
            type: dataType,
        };
        let updateSortOrder = sortState === null || sortState === void 0 ? void 0 : sortState.list.map((currentSort) => {
            if (key === (currentSort === null || currentSort === void 0 ? void 0 : currentSort.key))
                return Object.assign(Object.assign({}, currentSort), { order: currentSortstate === null || currentSortstate === void 0 ? void 0 : currentSortstate.order });
            return Object.assign(Object.assign({}, currentSort), { order: ESortOrder.UNCHANGED });
        });
        let finalSortList = { list: updateSortOrder };
        setSortState(finalSortList);
        setFinalSortState(currentSortstate);
    };
    const getSortedData = (sortstate, finalSortList) => {
        if (txnDI.transactionHistory.allTxns.transactionList.length > 0) {
            let sortedData = mainDI.common.getSortedData(txnDI.transactionHistory.allTxns.transactionList, sortstate.order !== 0 && sortstate.order === 1, sortstate.key, sortstate.type);
            txnDI.transactionHistory.saveSortedTxnHistory(finalSortList, sortstate, Object.assign(Object.assign({}, txnDI.transactionHistory.allTxns), { transactionList: sortedData }));
        }
    };
    useEffect(() => {
        getSortedData(finalSortState, sortState);
    }, [finalSortState, sortState]);
    const THTableColumn = [
        {
            columnName: "",
            keysForCustomFunction: ["editable", "tranId", "scripIdentifier"],
            tdCustomFunction: (keys) => {
                if (keys[0]) {
                    return (React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-edit" })));
                }
                return null;
            },
            columnClassName: "brd-left",
            trCustomFunctionOnClickoftd: (e, row) => {
                e.stopPropagation();
                props === null || props === void 0 ? void 0 : props.gotoEditTransaction(row);
            },
        },
        {
            columnName: "Date",
            arrows: true,
            key: "transactionDate",
            applySorting: true,
            type: "Date",
            columnClassName: "text-nowrap",
            tdCustomFunction: (key) => {
                return React.createElement("label", null, key);
            },
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Script Name",
            arrows: true,
            key: "security",
            applySorting: true,
            type: "string",
            keysForCustomFunction: ["quote"],
            tdCustomFunction: (keys) => {
                let quote = keys[0];
                return (React.createElement(ReadMoreTextWithReRender, { text: quote === null || quote === void 0 ? void 0 : quote.displayName, className: "", maxLength: 30 }));
            },
            columnClassName: "table-classNameWidth readMore-txnHistory",
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Action",
            arrows: true,
            key: "action",
            applySorting: true,
            type: "string",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: (action) => {
                return (React.createElement("label", { className: `${action.toUpperCase() === "BUY" ? "txt_green" : "txt_bloodRed"}` }, action.toUpperCase()));
            },
        },
        {
            columnName: "Quantity",
            arrows: true,
            key: "quantity",
            applySorting: true,
            type: "number",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: NonStreamReportValue,
        },
        {
            columnName: "Price",
            arrows: true,
            key: "transactionPrice",
            applySorting: true,
            type: "number",
            tdCustomFunction: NonStreamReportValue,
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
        },
        {
            columnName: "Brokerage & Charges",
            arrows: true,
            key: "netCharges",
            applySorting: true,
            type: "number",
            tdCustomFunction: NonStreamReportValue,
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
        },
        {
            columnName: "Net Value",
            arrows: true,
            key: "netValue",
            applySorting: true,
            type: "number",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: NonStreamReportValue,
        },
        {
            columnName: "",
            arrows: false,
            keysForCustomFunction: [
                "edelweissTabShortCode",
                "edelweissProductShortCode",
                "txnFlag",
                "tranId",
                "txnType",
            ],
            tdCustomFunction: (vals) => {
                var _a, _b;
                let [edelweissTabShortCode, edelweissProductShortCode, txnFlag, tranId, txnType,] = vals;
                return (React.createElement(FilterFlags, { rowId: tranId.toString(), parentClass: "justify-content-end pt-1 px-1", filterFlags: {
                        corporateAction: false,
                        research: false,
                        news: false,
                    }, tags: [
                        {
                            tagName: String(edelweissTabShortCode).toLocaleUpperCase(),
                            className: "product-filter-tags orange-light-tag",
                            edelweissProdTooltipDesc: (_a = NuvamaAssets.get(edelweissTabShortCode)) === null || _a === void 0 ? void 0 : _a.display,
                            placement: "top",
                            parentClass: "rebrandreports-tooltip-hover",
                            tagId: tranId + "1",
                        },
                        {
                            tagName: String(edelweissProductShortCode).toLocaleUpperCase(),
                            className: "product-filter-tags orange-light-tag",
                            edelweissProdTooltipDesc: (_b = NuvamaProducts.get(edelweissProductShortCode)) === null || _b === void 0 ? void 0 : _b.display,
                            placement: "top",
                            parentClass: "rebrandreports-tooltip-hover",
                            tagId: tranId + "2",
                        },
                        {
                            tagName: String(txnType).toLocaleUpperCase(),
                            className: "product-filter-tags txn-type",
                            edelweissProdTooltipDesc: txnType,
                            placement: "top",
                            parentClass: "rebrandreports-tooltip-hover",
                            tagId: tranId + "3",
                        },
                    ] }));
            },
            columnClassName: "brd-right",
        },
    ];
    return (React.createElement(React.Fragment, null,
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(ReportsGenericTable, { columns: THTableColumn, data: THData.allTransactionHistory.transactionList, applyExternalSort: applySort, parentClassName: "common-table-border table", rowOnClick: props === null || props === void 0 ? void 0 : props.handleRowClick, tableClassName: "transaction-history-table", rowClassName: (txn) => {
                var _a;
                return `hand_cursor p-0 ${((_a = props === null || props === void 0 ? void 0 : props.selectedTxnRow) === null || _a === void 0 ? void 0 : _a.tranId) === (txn === null || txn === void 0 ? void 0 : txn.tranId)
                    ? "selected-txn-row"
                    : ""}`;
            } })) : (React.createElement(AlltxnsOfAllScripsCards, { transactionList: THData.allTransactionHistory.transactionList, handleRowClick: props === null || props === void 0 ? void 0 : props.handleRowClick, gotoEditTransaction: props === null || props === void 0 ? void 0 : props.gotoEditTransaction })),
        React.createElement(LoadDataOnscroll, null)));
};
export default AlltxnsOfAllScrips;
